const scrollToFirstBlock = {
    ui: {},

    init: function() {
        this.bindUI();
        this.bindEvents();
    },

    bindUI: function() {
        this.ui.$buttonToScroll = $(".js-scrollToFirstBlock");
        this.ui.$blocks = $(".section, .js-block");
    },

    bindEvents: function() {
        this.ui.$buttonToScroll.on('click', this.scrollTo.bind(this));
    },

    scrollTo: function(e) {
        if(this.ui.$blocks.length > 0){
            this.ui.$blocks[0].scrollIntoView({behavior: 'smooth'});
        }else{
            // pour les pages sans bloc évite à "faux-bug"
            $('.pushNewsletter, .footer')[0].scrollIntoView({behavior: 'smooth'});
        }
    }
}

module.exports = scrollToFirstBlock;